<template>
  <div>
    <div class="divButtonRigth">
      <el-button type="primary" v-if="currentTab=='exe'" size="small" @click="customHeader">自定义表头</el-button>
    </div>
    <el-dialog
      ref=""
      id="dialog1"
      width="740px"
      v-dialogDrag
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="自定义表头"
      :visible.sync="dialogheaderVisible"
    >
      <customHeader :infoSetId="tablePar.infoSetId" :modelType="currentTab" :headerList.sync="headerList"
      >

      </customHeader>
      <div
        class="marginTop30"
        style="text-align: center"
      >
        <el-button
          type="primary"
          @click="saveCusHeader()"
        >
          确认
        </el-button>
        <el-button @click="dialogheaderVisible = false">
          取消
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import customHeader from "@/views/wage/report/ciic-custom-table-header/index";
  export default {
    name: "step1",
    data(){
      return{
        dialogheaderVisible: false,
        tablePar:{
          infoSetId:'CUS_BASE_INFO',
          modelType:'',
          infoItemList:[],
          memberId:'',
        },
        currentTab:'exe',
        headerList:[],
      }
    },
    components: {customHeader},

    methods:{
      customHeader() {
        this.dialogheaderVisible = true
      },
    }
  };
</script>
